import React from "react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis } from "recharts";
import { Layers, Keyboard, CheckCircle2, AlertTriangle } from "lucide-react";
import { useCurrency } from "@shared/selectors/globalSelectors";

export const SlipLotDetailsDashboard = ({ data }: any) => {
  const currency = useCurrency();
  const kpiData = [
    {
      title: "Physical Count",
      count: data?.physicalSlipCount || 0,
      trendSummary: "From handover sheet",
      icon: <Layers className="h-8 w-8 text-slate-500" />,
    },
    {
      title: "Entered",
      count: data?.enteredCount || 0,
      trendSummary: `${data?.countMismatch || 0} missing`,
      icon: <Keyboard className="h-8 w-8 text-blue-500" />,
    },
    {
      title: "Valid / Posted",
      count: data?.validCount || 0,
      trendSummary: `${currency} ${data?.postedTotal || "0.00"} posted`,
      icon: <CheckCircle2 className="h-8 w-8 text-green-500" />,
    },
    {
      title: "Flagged",
      count: data?.flaggedCount || 0,
      trendSummary: data?.flaggedCount
        ? `${data.flaggedCount} exceptions`
        : "No exceptions",
      icon: <AlertTriangle className="h-8 w-8 text-red-500" />,
    },
  ];
  return (
    <div className="space-y-4 mt-6">
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {kpiData.map((kpi, index) => (
          <QuickStatsCard
            key={index}
            title={kpi.title}
            count={kpi.count}
            trendSummary={kpi.trendSummary}
            icon={kpi.icon}
          />
        ))}
      </div>

      {/* Progress Bar */}
      <div className="bg-white border rounded-xl p-4 overflow-hidden shadow-sm">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-2 text-sm font-semibold text-gray-900">
            Entry Progress
            <span className="text-gray-400 font-normal mx-1">·</span>
            <span className="text-green-600">
              {data?.validCount || 0} valid
            </span>
            <span className="text-gray-400 font-normal mx-1">·</span>
            <span className="text-slate-400">
              {data?.flaggedCount || 0} flagged
            </span>
            <span className="text-gray-400 font-normal mx-1">·</span>
            <span className="text-slate-600">
              {data?.enteredCount || 0} / {data?.physicalSlipCount || 0}
            </span>
          </div>
          <div className="text-sm font-bold text-gray-900">
            {data?.progressPercentage || 0}%
          </div>
        </div>

        <div className="h-3 w-full mt-1">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              layout="vertical"
              data={[
                { name: "Progress", value: data?.progressPercentage || 0 },
              ]}
              margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            >
              <XAxis type="number" domain={[0, 100]} hide />
              <YAxis dataKey="name" type="category" hide />
              <Bar
                dataKey="value"
                fill="#16a34a"
                background={{ fill: "#f1f5f9", radius: [4, 4, 4, 4] }}
                radius={[4, 4, 4, 4]}
                barSize={12}
                isAnimationActive={true}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default SlipLotDetailsDashboard;
